import { useEffect, useState } from "react"
import { ProjectProps } from "../../interfaces/project_types"
import { getActiveProjects } from "../../api/projects"
import { RouteButton } from "../Buttons"
import { Header } from "../misc"
import { ManagerSection } from "./utils/ManagerSection"

/**
 *  ### [Route for ('/project_status_report/:id')]
 * 
 * This component shows the status of a project based on the project id.
 */
export function ProjectStatusReport() {
    /**
     * TODO:
     * - Make the page printable
     */
    const [project, setProject] = useState<ProjectProps[]>()
    const [managers, setManagers] = useState<string[]>([])

    useEffect(() => {
        const get_data = async () => {
            const response = await getActiveProjects()

            if (!response) {
                throw new Error("Error fetching project list")
            }

            const unique_managers = [...new Set(response.data.map(project => project.manager?.name))]

            setManagers(unique_managers as string[])
            setProject(response.data)
        }
        get_data()
    }, [])

    return(
        <>
            <Header />
            
            <h1 className="px-2 mb-5">Project Status Report</h1>

            {project && project.length === 0 && <h1 className="flex justify-center py-2">No projects found</h1>}

            {managers && managers.map((manager, index) => 
                <ManagerSection manager={manager} projects={project} index={index} key={index} />
            )}

            <div className="flex justify-center print:hidden">
                <RouteButton route="/main_menu" text="Back to Projects" />
            </div>
        </>
    )
}